import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';   // ✅ added useNavigate
import api from '../api';
import './Login.css';

function Signup() {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', company: '', password: '', confirmPassword: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();   // ✅ navigate hook

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/api/auth/signup', {
        name: form.name,
        email: form.email,
        password: form.password,
        phone: form.phone,
        company: form.company,
      });

      // ✅ Redirect to email verification page with the userId
      navigate(`/verify-email?userId=${res.data.userId}`, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  // Normal signup form (no success view – that's now on the VerifyEmail page)
  return (
    <div className="login-page">
      <div className="login-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      {/* ── Back to Home arrow ── */}
      <Link
        to="/"
        style={{
          position: 'fixed',
          top: '1.25rem',
          left: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.4rem',
          color: 'rgba(255,255,255,0.75)',
          fontSize: '0.9rem',
          fontWeight: 500,
          zIndex: 100,
          transition: 'color 0.2s',
          textDecoration: 'none',
        }}
        onMouseEnter={e => e.currentTarget.style.color = '#fff'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
      >
        ← Home
      </Link>

      <div className="login-container">
        {/* Left Branding Panel */}
        <div className="login-brand">
          <div className="brand-lock">🔐</div>
          <h1>Recovery Vault</h1>
          <p className="brand-tagline">Institutional‑grade security for your digital assets</p>
          <div className="brand-stats">
            <div className="brand-stat">
              <span className="stat-number">$126M+</span>
              <span className="stat-label">Protected</span>
            </div>
            <div className="brand-stat">
              <span className="stat-number">99.8%</span>
              <span className="stat-label">Verification</span>
            </div>
          </div>
        </div>

        {/* Right Form Panel */}
        <div className="login-form-panel">
          <div className="form-header">
            <h2>Create Your Vault Account</h2>
            <p>Join over 12,000 institutions and individuals</p>
          </div>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <span className="input-icon">👤</span>
              <input name="name" placeholder="Full Name" onChange={handleChange} required />
            </div>
            <div className="input-group">
              <span className="input-icon">📧</span>
              <input name="email" type="email" placeholder="Email address" onChange={handleChange} required />
            </div>
            <div className="input-group">
              <span className="input-icon">📞</span>
              <input name="phone" placeholder="Phone Number" onChange={handleChange} />
            </div>
            <div className="input-group">
              <span className="input-icon">🏢</span>
              <input name="company" placeholder="Company (optional)" onChange={handleChange} />
            </div>
            <div className="input-group">
              <span className="input-icon">🔒</span>
              <input name="password" type="password" placeholder="Password (min 8 chars)" onChange={handleChange} required />
            </div>
            <div className="input-group">
              <span className="input-icon">🔒</span>
              <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={handleChange} required/>
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              <span>{loading ? 'Creating Account…' : 'Sign Up'}</span>
              <span className="btn-arrow">→</span>
            </button>

            <div className="form-links">
              <p className="switch-link">
                Already have an account? <Link to="/login">Log in</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Signup;
